import { useRef } from 'react';

/** @internal */
export type ItemHoverProps = {
  /** Whether or not the menu item is hovered. */
  isItemHovered: boolean;
  /** Handlers used to determine whether the itemis hovered. */
  hoverProps: {
    onMouseEnter: () => void;
    onMouseLeave: () => void;
    onKeyDown: () => void;
  };
};

/** @internal */
export function useIsMenuItemHovered(): ItemHoverProps {
  const isItemHovered = useRef(false);

  const onMouseEnter = () => (isItemHovered.current = true);
  const onMouseLeave = () => (isItemHovered.current = false);
  const onKeyDown = () => (isItemHovered.current = false);

  return {
    isItemHovered: isItemHovered.current,
    hoverProps: {
      onMouseEnter,
      onMouseLeave,
      onKeyDown,
    },
  };
}
